import _regeneratorRuntime from 'babel-runtime/regenerator';
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
  return typeof obj;
} : function (obj) {
  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};
var _this = this;
function _objectWithoutProperties(obj, keys) {
  var target = {};
  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }
  return target;
}
function _asyncToGenerator(fn) {
  return function () {
    var gen = fn.apply(this, arguments);
    return new Promise(function (resolve, reject) {
      function step(key, arg) {
        try {
          var info = gen[key](arg);
          var value = info.value;
        } catch (error) {
          reject(error);
          return;
        }
        if (info.done) {
          resolve(value);
        } else {
          return Promise.resolve(value).then(function (value) {
            step("next", value);
          }, function (err) {
            step("throw", err);
          });
        }
      }
      return step("next");
    });
  };
}
import { callAPI } from './apiActions';
import withdrawSubscriptionService from '../../services/subscriptions/withdrawSubscriptionService';
import { showSnack } from './snackbarActions';
import { closeWithdrawSidePane, closeSidePane } from './sidePaneActions';
import { formatErrorText } from '../../helpers/errorTextFormatter';
export var FETCH_PRODUCT_WITHDRAW_TEMPLATES = 'FETCH_PRODUCT_WITHDRAW_TEMPLATES';
export var FETCH_PRODUCT_WITHDRAW_TEMPLATE = 'FETCH_PRODUCT_WITHDRAW_TEMPLATE';
export var RECEIVE_WITHDRAW_TEMPLATES = 'RECEIVE_WITHDRAW_TEMPLATES';
export var RECEIVE_WITHDRAW_TEMPLATE = 'RECEIVE_WITHDRAW_TEMPLATE';
export var RECEIVE_WITHDRAW_TEMPLATES_ERROR = 'RECEIVE_WITHDRAW_TEMPLATE_ERROR';
export var RECEIVE_WITHDRAW_TEMPLATE_ERROR = 'RECEIVE_WITHDRAW_TEMPLATE_ERROR';
export var SUBMITTING_WITHDRAW = 'SUBMITTING_WITHDRAW';
export var RECEIVE_WITHDRAW_TICKET = 'RECEIVE_WITHDRAW_TICKET';
export var RECEIVE_WITHDRAW_TICKETS = 'RECEIVE_WITHDRAW_TICKETS';
export var RECEIVE_WITHDRAW_WORKFLOW_INFO = 'RECEIVE_WITHDRAW_WORKFLOW_INFO';
export var RECEIVE_WITHDRAW_FEE = 'RECEIVE_WITHDRAW_FEE';
export var RETAIL_FIAT_CONFIRM_WITHDRAW = 'RETAIL_FIAT_CONFIRM_DEPOSIT';
export var ADD_WITHDRAWAL_TICKET = 'ADD_WITHDRAWAL_TICKET';
export var fetchProductWithdrawTemplates = function fetchProductWithdrawTemplates(productId) {
  return function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(dispatch, getState) {
      var payload, data, _data;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              dispatch(fetchingWithdrawTemplates);
              payload = {
                ProductId: productId,
                OMSId: getState().user.userInfo.OMSId,
                AccountId: getState().user.selectedAccountId
              };
              _context.prev = 2;
              _context.next = 5;
              return dispatch(callAPI('GetWithdrawFormTemplateTypes', payload));
            case 5:
              data = _context.sent;
              if (!data.result) {
                _context.next = 12;
                break;
              }
              if (data.TemplateTypes.length) {
                _context.next = 9;
                break;
              }
              return _context.abrupt('return', dispatch(withdrawTemplatesError('There are no providers configured for this product')));
            case 9:
              dispatch(receiveWithdrawTemplates(data.TemplateTypes));
              if (data.TemplateTypes.length === 1) {
                dispatch(fetchProductWithdrawTemplate(productId, data.TemplateTypes[0].TemplateName));
              }
              return _context.abrupt('return', true);
            case 12:
              return _context.abrupt('return', dispatch(withdrawTemplatesError(data.errormsg)));
            case 15:
              _context.prev = 15;
              _context.t0 = _context['catch'](2);
              _context.next = 19;
              return dispatch(callAPI('GetWithdrawTemplateTypes', payload));
            case 19:
              _data = _context.sent;
              if (_data.result) {
                dispatch(fetchProductWithdrawTemplate(productId, _data.TemplateTypes[0]));
              }
              dispatch(withdrawTemplatesError(_data.errormsg));
            case 22:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this, [[2, 15]]);
    }));
    return function (_x, _x2) {
      return _ref.apply(this, arguments);
    };
  }();
};
export var fetchProductWithdrawTemplate = function fetchProductWithdrawTemplate(productId, templateType) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  return function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(dispatch, getState) {
      var templateTypeObj, payload, data;
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              dispatch(fetchingWithdrawTemplate(productId, templateType));
              templateTypeObj = getState().withdraw.templateTypes.find(function (type) {
                return type.TemplateName === templateType;
              });
              payload = Object.assign({
                OMSId: getState().user.userInfo.OMSId,
                AccountId: getState().user.selectedAccountId,
                ProductId: productId,
                TemplateType: templateType
              }, options);
              if (templateTypeObj) {
                payload.AccountProviderId = templateTypeObj.AccountProviderId;
              }
              _context2.next = 6;
              return dispatch(callAPI('GetWithdrawTemplate', payload));
            case 6:
              data = _context2.sent;
              if (!(data.result && data.Template)) {
                _context2.next = 9;
                break;
              }
              return _context2.abrupt('return', dispatch(receiveWithdrawTemplate(data)));
            case 9:
              return _context2.abrupt('return', dispatch(withdrawTemplateError(data.errormsg)));
            case 10:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, _this);
    }));
    return function (_x4, _x5) {
      return _ref2.apply(this, arguments);
    };
  }();
};
var createWithdrawTicket = function createWithdrawTicket(_ref3) {
  var ProductId = _ref3.ProductId,
    amount = _ref3.amount,
    iconFileName = _ref3.iconFileName,
    ProductSymbol = _ref3.ProductSymbol,
    ProductFullName = _ref3.ProductFullName,
    TemplateType = _ref3.TemplateType,
    info = _objectWithoutProperties(_ref3, ['ProductId', 'amount', 'iconFileName', 'ProductSymbol', 'ProductFullName', 'TemplateType']);
  return function () {
    var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(dispatch, getState) {
      var OMSId, AccountId, templateForm, templateType, templateTypeObj, payload, withdrawStatus, workflowDetail;
      return _regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              dispatch(submittingWithdraw);
              OMSId = getState().user.userInfo.OMSId;
              AccountId = getState().user.selectedAccountId;
              templateForm = info.TemplateForm || info;
              templateType = TemplateType || getState().withdraw.templateType;
              templateTypeObj = getState().withdraw.templateTypes.find(function (template) {
                return template.TemplateName === templateType;
              });
              // Since undefined is not serializable we default every prop to an empty string to avoid missing fields

              Object.keys(templateForm).forEach(function (prop) {
                return templateForm[prop] = templateForm[prop] || '';
              });
              payload = {
                OMSId: OMSId,
                AccountId: AccountId,
                ProductId: +ProductId,
                Amount: +info.Amount,
                TemplateForm: JSON.stringify(templateForm),
                TemplateType: templateType
              };
              if (templateTypeObj) {
                payload.AccountProviderId = templateTypeObj.AccountProviderId;
              }
              _context3.next = 11;
              return dispatch(callAPI('CreateWithdrawTicket', payload));
            case 11:
              withdrawStatus = _context3.sent;
              if (!(withdrawStatus.result === false)) {
                _context3.next = 14;
                break;
              }
              return _context3.abrupt('return', dispatch(showSnack({
                id: 'withdrawRejectSnack',
                text: formatErrorText(withdrawStatus),
                type: 'warning'
              })));
            case 14:
              _context3.prev = 14;
              workflowDetail = JSON.parse(withdrawStatus.detail);
              if (!((typeof workflowDetail === 'undefined' ? 'undefined' : _typeof(workflowDetail)) === 'object' && workflowDetail.ReplyObject && workflowDetail.ReplyObject !== '0')) {
                _context3.next = 18;
                break;
              }
              return _context3.abrupt('return', dispatch(receiveWithdrawWorkflowInfo(workflowDetail)));
            case 18:
              _context3.next = 22;
              break;
            case 20:
              _context3.prev = 20;
              _context3.t0 = _context3['catch'](14);
            case 22:
              dispatch(closeWithdrawSidePane());
              dispatch(showSnack({
                id: 'withdrawSuccessSnack',
                // context.t("Your withdraw has been successfully added, please check email for instructions.")
                text: 'Your withdraw has been successfully added, please check email for instructions.',
                type: 'success'
              }));
              dispatch(receiveWithdrawTicket(withdrawStatus));
              return _context3.abrupt('return', dispatch(getWithdrawTickets(AccountId, OMSId)));
            case 26:
            case 'end':
              return _context3.stop();
          }
        }
      }, _callee3, _this, [[14, 20]]);
    }));
    return function (_x6, _x7) {
      return _ref4.apply(this, arguments);
    };
  }();
};
export { createWithdrawTicket };
export var getWithdrawFee = function getWithdrawFee(ProductId, Amount) {
  return function () {
    var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(dispatch, getState) {
      var OMSId, AccountId, payload, withdrawFee;
      return _regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              OMSId = getState().user.userInfo.OMSId;
              AccountId = getState().user.selectedAccountId;
              payload = {
                OMSId: OMSId,
                ProductId: ProductId,
                AccountId: AccountId,
                Amount: Amount
              };
              _context4.next = 5;
              return dispatch(callAPI('GetWithdrawFee', payload));
            case 5:
              withdrawFee = _context4.sent;
              if (!(withdrawFee.result === false)) {
                _context4.next = 8;
                break;
              }
              return _context4.abrupt('return', dispatch(showSnack({
                id: 'withdrawRejectSnack',
                text: formatErrorText(withdrawFee),
                type: 'warning'
              })));
            case 8:
              dispatch(receiveWithdrawFee(withdrawFee));
            case 9:
            case 'end':
              return _context4.stop();
          }
        }
      }, _callee4, _this);
    }));
    return function (_x8, _x9) {
      return _ref5.apply(this, arguments);
    };
  }();
};
export var cancelWithdrawTicket = function cancelWithdrawTicket(_ref6) {
  var RequestCode = _ref6.RequestCode;
  return function () {
    var _ref7 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(dispatch, getState) {
      var _getState$user$userIn, OMSId, UserId, AccountId, payload, withdrawStatus;
      return _regeneratorRuntime.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              _getState$user$userIn = getState().user.userInfo, OMSId = _getState$user$userIn.OMSId, UserId = _getState$user$userIn.UserId;
              AccountId = getState().user.selectedAccountId;
              payload = {
                OMSId: OMSId,
                UserId: UserId,
                AccountId: AccountId,
                RequestCode: RequestCode
              };
              _context5.next = 5;
              return dispatch(callAPI('CancelWithdraw', payload));
            case 5:
              withdrawStatus = _context5.sent;
              if (!(withdrawStatus.result === false)) {
                _context5.next = 8;
                break;
              }
              return _context5.abrupt('return', dispatch(showSnack({
                id: 'cancelWithdrawSnack',
                text: formatErrorText(withdrawStatus),
                type: 'warning'
              })));
            case 8:
              // context.t('Your withdraw has been successfully canceled')
              dispatch(showSnack({
                id: 'cancelWithdrawSuccessSnack',
                text: 'Your withdraw has been successfully canceled',
                type: 'success'
              }));
              dispatch(getWithdrawTickets(AccountId, OMSId));
            case 10:
            case 'end':
              return _context5.stop();
          }
        }
      }, _callee5, _this);
    }));
    return function (_x10, _x11) {
      return _ref7.apply(this, arguments);
    };
  }();
};
export var subscribeToWithdrawalTickets = function subscribeToWithdrawalTickets() {
  return function (dispatch) {
    withdrawSubscriptionService.subscribe(function (updates) {
      dispatch(addWithdrawalTicket(updates));
    });
  };
};
export var addWithdrawalTicket = function addWithdrawalTicket(payload) {
  return {
    type: ADD_WITHDRAWAL_TICKET,
    payload: payload
  };
};
export var fetchingWithdrawTemplates = {
  type: FETCH_PRODUCT_WITHDRAW_TEMPLATES
};
export var fetchingWithdrawTemplate = function fetchingWithdrawTemplate(product, templateType) {
  return {
    type: FETCH_PRODUCT_WITHDRAW_TEMPLATE,
    payload: {
      product: product,
      templateType: templateType
    }
  };
};
export var receiveWithdrawTemplates = function receiveWithdrawTemplates(payload) {
  return {
    type: RECEIVE_WITHDRAW_TEMPLATES,
    payload: payload
  };
};
export var receiveWithdrawTemplate = function receiveWithdrawTemplate(payload) {
  return {
    type: RECEIVE_WITHDRAW_TEMPLATE,
    payload: payload
  };
};
export var withdrawTemplatesError = function withdrawTemplatesError(payload) {
  return {
    type: RECEIVE_WITHDRAW_TEMPLATES_ERROR,
    payload: payload
  };
};
export var withdrawTemplateError = function withdrawTemplateError(payload) {
  return {
    type: RECEIVE_WITHDRAW_TEMPLATE_ERROR,
    payload: payload
  };
};
export var submittingWithdraw = {
  type: SUBMITTING_WITHDRAW
};
export var receiveWithdrawTicket = function receiveWithdrawTicket(payload) {
  return {
    type: RECEIVE_WITHDRAW_TICKET,
    payload: payload
  };
};
export var receiveWithdrawFee = function receiveWithdrawFee(payload) {
  return {
    type: RECEIVE_WITHDRAW_FEE,
    payload: payload
  };
};
export var receiveWithdrawTickets = function receiveWithdrawTickets(payload) {
  return {
    type: RECEIVE_WITHDRAW_TICKETS,
    payload: payload
  };
};
export var receiveWithdrawWorkflowInfo = function receiveWithdrawWorkflowInfo(payload) {
  return {
    type: RECEIVE_WITHDRAW_WORKFLOW_INFO,
    payload: payload
  };
};
export var getWithdrawTickets = function getWithdrawTickets(AccountId, OMSId) {
  return function () {
    var _ref8 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6(dispatch) {
      var withdrawTickets;
      return _regeneratorRuntime.wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              _context6.next = 2;
              return dispatch(callAPI('GetWithdrawTickets', {
                AccountId: AccountId,
                OMSId: OMSId
              }));
            case 2:
              withdrawTickets = _context6.sent;
              dispatch(receiveWithdrawTickets(withdrawTickets));
            case 4:
            case 'end':
              return _context6.stop();
          }
        }
      }, _callee6, _this);
    }));
    return function (_x12) {
      return _ref8.apply(this, arguments);
    };
  }();
};
export var RECEIVE_VERIFICATION_LEVEL_CONFIGS = 'RECEIVE_VERIFICATION_LEVEL_CONFIGS';
var receiveVerificationLevelConfigs = function receiveVerificationLevelConfigs(payload) {
  return {
    type: RECEIVE_VERIFICATION_LEVEL_CONFIGS,
    payload: payload
  };
};
export var getAccountVerificationLevelConfig = function getAccountVerificationLevelConfig() {
  return function () {
    var _ref9 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7(dispatch, getState) {
      var state;
      return _regeneratorRuntime.wrap(function _callee7$(_context7) {
        while (1) {
          switch (_context7.prev = _context7.next) {
            case 0:
              state = getState();
              _context7.next = 3;
              return dispatch(callAPI('GetVerificationLevelConfig', {
                OMSId: state.user.userInfo.OMSId,
                AccountId: state.user.selectedAccountId
              })).then(function (res) {
                return dispatch(receiveVerificationLevelConfigs(res));
              });
            case 3:
            case 'end':
              return _context7.stop();
          }
        }
      }, _callee7, _this);
    }));
    return function (_x13, _x14) {
      return _ref9.apply(this, arguments);
    };
  }();
};